<template>
    <div class="nbq_container">
        <div :style="`width: ${treeOuterWidth}px,height: calc(100% - 1rem - 40px)`">
            <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="title"> -->
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :defaultExpandAll="true"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultExpandedKeys"
                :isSingle="true"
                @handleStretchClick="handleStretchClick"
            ></me-tree>
            <!-- </me-collapes> -->
        </div>
        <div class="nbq_monitor" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <div class="elec_left">
                <div class="elec_left_top">
                    <div class="elec_left_title">
                        <img src="../../../assets/image/custom/elec_left_line.png"/>
                        <span>{{ curPoint && curPoint.point_name }}</span>
                    </div>
                    <div class="elec_common_item">
                        <div class="elec_common_item_line elec_custom left_top" style="width: 100% !important; height: 40%; align-items: center !important">
                            <div class="left_top_chart"></div>
                        </div>
                        <div class="elec_common_item_line elec_custom left_top" style="flex: 1 !important">
                            <div class="elec_item_inner">
                                <div class="inner_item">
                                    <div>压缩空气温度：</div>
                                    <div></div>
                                </div>
                                <div class="inner_item">
                                    <div>压缩空气压力：</div>
                                    <div></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="elec_left_center"
                    v-loading="gljc_loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="elec_left_title">
                        <img src="../../../assets/image/custom/elec_left_line.png"/>
                        <span>用量统计</span>
                    </div>
                    <div class="elec_common_item">
                        <div class="elec_custom_line">
                            <div class="elec_item_line_pic"><img src="../../../assets/image/custom/bwg_elec.png"/></div>
                            <div class="elec_item_line_cnt" style="width: 8rem;">日使用量：<i></i></div>
                        </div>
                        <div class="elec_custom_line">
                            <div class="elec_item_line_pic"><img src="../../../assets/image/custom/bwg_elec.png"/></div>
                            <div class="elec_item_line_cnt" style="width: 8rem;">月使用量：<i></i></div>
                  
                        </div>
                        <!-- <div class="elec_custom_line">
                            <div class="elec_item_line_pic"><img src="../../../assets/image/custom/bwg_elec.png"/></div>
                            <div class="elec_item_line_cnt" style="width: 8rem;">年发电量：<i>29635</i></div>
                            <div>kWh</div>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="elec_left_bottom">
                    <div class="elec_left_title">
                        <img src="../../../assets/image/custom/elec_left_line.png"/>
                        <span>功率监测</span>
                    </div>
                    <div class="left_bottom_choose">
                        <div class="choose_s">日</div>
                        <div class="choose_us">月</div>
                        <div class="choose_us">年</div>
                    </div>
                    <div class="elec_chart_div">
                        <v-chart
                            :auto-resize="true"
                            :options="line"
                            ref="line"
                            theme="ovilia-green"
                        />
                    </div>
                </div> -->
            </div>
            <div class="elec_right">
                <div class="elec_right_item">
                    <div class="elec_title_div">
                        <img class="elec_title" src="../../../assets/image/custom/elec_title.png"/>
                        <span>瞬时分析</span>
                    </div>
                    <el-form label-width="60px" :model="searchForm" class="leader-style-form">
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="searchForm.from_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="disableDate"
                                :clearable="false"
                                :editable="false"
                            ></el-date-picker>
                            <span style="color: #fff;display: inline-block; padding: 0 20px">至</span>
                            <el-date-picker
                                v-model="searchForm.to_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="disableDate"
                                :clearable="false"
                                :editable="false"
                            ></el-date-picker>
                            <el-button
                                type="primary"
                                size="medium"
                                class="leader-common-button"
                                @click="search"
                            >查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="tab_cont">
                        <el-radio-group v-model="tabVal"  class="leader-radio">
                            <el-radio-button value="1" key="1" :label="1">温度</el-radio-button>
                            <el-radio-button value="2" key="2" :label="2">压力</el-radio-button>
                            <el-radio-button value="3" key="3" :label="3">瞬时流量</el-radio-button>
                        </el-radio-group>
                        <div class="btn_cont">
                            <el-button
                                icon="el-icon-menu"
                                class="leader-common-button"
                                @click="doOpen1"
                            >放大</el-button>
                            <el-button
                                icon="el-icon-menu"
                                class="leader-common-button"
                                @click="tableSwitch = true"
                            >图表</el-button>
                            <el-button
                                icon="el-icon-date"
                                class="leader-common-button"
                                @click="tableSwitch = false"
                            >数据</el-button>
                        </div>
                    </div>
                    <div class="chart_cont" style="height:calc(100% - 8.5rem)">
                        <div
                            class="echart-container"
                            v-if="this.tableSwitch"
                            v-loading="loading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <v-chart :auto-resize="true" :options="lineRight1" ref="lineRight1" />
                        </div>
                        <div class="table-container" v-if="!this.tableSwitch">
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    :data="tableData"
                                    border
                                    v-loading="Tloading"
                                    class="leader-style-table"
                                    style="width: auto;"
                                >
                                    <el-table-column
                                        v-for="val in tableHeader"
                                        :key="val.column_val"
                                        :prop="val.column_val"
                                        :label="val.column_key"
                                        align="center"
                                    ></el-table-column>
                                </el-table>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
                <div class="elec_right_item">
                    <div class="elec_title_div">
                        <img class="elec_title" src="../../../assets/image/custom/elec_title.png"/>
                        <span>流量趋势分析</span>
                    </div>
                    <el-form label-width="60px" :model="searchForm2" class="leader-style-form">
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="searchForm2.from_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="disableDate"
                                :clearable="false"
                                :editable="false"
                            ></el-date-picker>
                            <span style="color: #fff;display: inline-block; padding: 0 20px">至</span>
                            <el-date-picker
                                v-model="searchForm2.to_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="disableDate"
                                :clearable="false"
                                :editable="false"
                            ></el-date-picker>
                            <el-button
                                type="primary"
                                size="medium"
                                class="leader-common-button"
                                @click="search2"
                            >查询</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="tab_cont">
                        <el-radio-group v-model="tabVal2" class="leader-radio">
                            <el-radio-button value="1" key="1" :label="1">累计流量</el-radio-button>
                        </el-radio-group>
                        <div class="btn_cont">
                            <el-button
                                icon="el-icon-menu"
                                class="leader-common-button"
                                @click="doOpen2"
                            >放大</el-button>
                            <el-button
                                icon="el-icon-menu"
                                class="leader-common-button"
                                @click="tableSwitch2 = true"
                            >图表</el-button>
                            <el-button
                                icon="el-icon-date"
                                class="leader-common-button"
                                @click="tableSwitch2 = false"
                            >数据</el-button>
                        </div>
                    </div>
                    <div class="chart_cont">
                        <div
                            class="echart-container"
                            v-if="this.tableSwitch2"
                            v-loading="loading2"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <v-chart :auto-resize="true" :options="lineRight2" ref="lineRight2" />
                        </div>
                        <div class="table-container" v-if="!this.tableSwitch2">
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    :data="tableData2"
                                    border
                                    v-loading="Tloading"
                                    class="leader-style-table"
                                >
                                    <el-table-column
                                        v-for="val in tableHeader2"
                                        :key="val.column_val"
                                        :prop="val.column_val"
                                        :label="val.column_key"
                                        align="center"
                                    ></el-table-column>
                                </el-table>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ys1_monitor_module :curPoint="curPoint" :dialogStatus.sync="dialogStatus1" :searchForm="searchForm" @closeDiaCb="closeDiaCb1"></ys1_monitor_module>
        <ys2_monitor_module :curPoint="curPoint" :dialogStatus.sync="dialogStatus2" :searchForm="searchForm2" @closeDiaCb="closeDiaCb2"></ys2_monitor_module>
    </div>
</template>
<script>
import "echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import dayjs from "dayjs";
import Tree from "@/comon/components/tree.vue";
import NbqInstantModule from "./nbq_instant_module.vue";
import NbqMonitorModule from "./nbq_monitor_module.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import { getDataAll } from "@/http/http-60.js";
import * as api from "@/http/api.js";
import Ys1_monitor_module from "views/pages/bwg/ys1_monitor_module.vue";
import Ys2_monitor_module from "views/pages/bwg/ys2_monitor_module.vue";
export default {
    components: {
        Ys2_monitor_module,
        Ys1_monitor_module,
        "me-tree": Tree,
        "me-collapes": Collapes,
        NbqInstantModule,
        NbqMonitorModule,
    },
    data() {
        return {
            gljc_loading: false,
            dialogStatus1: false,
            dialogStatus2: false,
            treeData: [],
            treeOuterWidth: 280,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            treeLoading: false,
            treeToolBar: false,
            nowClick: {},
            searchForm: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD')
            },
            searchForm2: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD')
            },
            tabVal: "1",
            tabVal2: "1",
            radioButtons: ['温度','压力','瞬时流量'],
            radioButtons2: ['累计流量'],
            curPoint: {point_name: '压缩空气'},
            x_list: [],
            series: [],
            legend: [],
            tableHeader: [],
            unit: '',
            tableData: [],
            tableSwitch: true,
            x_list2: [],
            series2: [],
            legend2: [],
            tableHeader2: [],
            unit2: '',
            tableData2: [],
            tableSwitch2: true,
            loading: null,
            loading2: null,
        };
    },
    created() {
        this.getCommonPointList('013')
    },
    methods: {
        doOpen1() {
            this.dialogStatus1 = true;
        },
        doOpen2() {
            this.dialogStatus2 = true;
        },
        //获取采集点
        getCommonPointList(point_class_id) {
            api.getCommonPointList({ point_class_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    // this.defaultCheckKeys = this.defaultExpandedKeys = [
                    //     formatData.firstPoint.point_id,
                    // ];
                    //this.getData(formatData.firstPoint);
                    //this.$refs.myTree.handleNodeClick(formatData.firstPoint);
                }
            });
        },
        async getData(point) {
            this.gljc_loading = true;
            let pointIds = [point.point_id];           
            await getDataAll(pointIds).then(res => {
                if (res && res.error_code === "0") {
                    let valueJson = res.bus_json;
                    let data = valueJson[point.point_id];
                    this.curPoint['p'] = data && data.p;
                    this.curPoint['dtfdl'] = data && data.dangtianfadianliang;
                    this.curPoint['zfdl'] = data && data.zongfadianliang;
                    this.curPoint['os'] = data && data.operatingstate;
                    this.$nextTick(()=> {
                        setInterval(() => {
                            this.gljc_loading = false;
                        }, 2000);
                    })
                } else {
                    this.gljc_loading = false;
                }
               
            });
        },
 
        async search() {
            await this.getRealTimeData1(this.tabVal);
        },
        async search2() {
            await this.getRealTimeData2(this.tabVal2);
        },
        async tabChange(point_class_column_kind_id) {
            this.tabVal = point_class_column_kind_id;
            await this.getRealTimeData1(point_class_column_kind_id);
        },
        async tabChange2(point_class_column_kind_id) {
            this.tabVal2 = point_class_column_kind_id;
            await this.getRealTimeData2(this.tabVal2);
        },
        async getRealTimeData1(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loading = true;
            await api.getRealTimeData({
                from_date: this.searchForm.from_date,
                to_date: this.searchForm.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    // 表格头部
                    this.tableHeader = [
                        {
                            column_key: "采集时间",
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit = item.column_unit;
                        this.legend.push(item.column_desc);
                        this.series.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader.push(header_obj);
                    });

                    //  表格
                    this.tableData = [];
                    this.x_list.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loading = false;
                    // }, 5000)

                }
            });
        },
        async getRealTimeData2(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loading2 = true;
            await api.getRealTimeData({
                from_date: this.searchForm2.from_date,
                to_date: this.searchForm2.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list2 = res.bus_json.x_list;
                    // 数据
                    this.series2 = [];
                    // 图例
                    this.legend2 = [];

                    // 表格头部
                    this.tableHeader2 = [
                        {
                            column_key: "采集时间",
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit2 = item.column_unit;
                        this.legend2.push(item.column_desc);
                        this.series2.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader2.push(header_obj);
                    });

                    //  表格
                    this.tableData2 = [];
                    this.x_list2.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData2.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loading2 = false;
                    // }, 5000)

                }
            });
        },
        /**
         * 格式化tree disabled状态；
         */
         tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.collector_id) {
                    //实采集点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                } else {
                    //虚点
                    obj.disabled = true;
                    resultArr.push(obj.point_id);
                }
                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        async handleTreeNodeClick(sth) {
            this.curPoint = sth;
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        }
    },
    computed: {
        lineRight1() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legend,
                    itemHeight: 14,
                    textStyle: {
                        fontSize: 10,
                        lineHeight: 12,
                        color: "#fff"
                    },
                    type: 'scroll',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#666666',
                    pageTextStyle: {
                        color: '#fff',
                    },
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    }
                },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                       // rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `${this.unit}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "35%",
                    containLabel: true
                },
                series: this.series,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
        lineRight2() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legend2,
                    itemHeight: 14,
                    textStyle: {
                        fontSize: 10,
                        lineHeight: 12,
                        color: "#fff"
                    },
                    type: 'scroll',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#666666',
                    pageTextStyle: {
                        color: '#fff',
                    },
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    }
                },
                calculable: true,
                xAxis: {
                    data: this.x_list2,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                     //   rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `${this.unit2}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "35%",
                    containLabel: true
                },
                series: this.series2,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
    },
};
</script>
<style lang="scss">
.nbq_container {
    width: 100%;
    height: 100%;
    padding: 0 2rem;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    .leader-common-button {
        padding: 0.5rem;
    }
    .tree_container {
        padding-bottom: 10px;
        height: calc(100% - 10px);
    }
    .nbq_monitor {
        margin-left: 40px;
        height: 100%;
        display: inline-flex;
        justify-content: space-between;
        .elec_left {
            width: 25%;
            height: 100%;
            margin-right: 2%;
            display: inline-flex;
            flex-flow: column wrap;
            justify-content: space-between;
            .elec_left_title {
                //  background: url(../../../assets/image/custom/elec_left_line.png) no-repeat;
                color: #56FCFF;
                //  background-size: 100% 100%;
                text-align: center;
                // height: 0.5rem;
                // width: 100%;
                width: 100%;
                height: 2.5rem;
                position: relative;
                span {
                    position: absolute;
                    top: 50%; 
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 1rem;
                }
                img {
                    width: 100%;
                    height: auto;
                    position: absolute;
                    top: 50%; 
                    left: 0;
                    transform: translate(0, -50%);
                }
            }
            .elec_common_item {
                display: inline-flex;
                flex-flow: column wrap;
                justify-content: space-evenly;
                width: 100%;
                height: calc(100% - 2rem);
                .elec_common_item_line {
                    flex: 1;
                    display: inline-flex;
                    width: 100%;
                    align-items: center;
                    font-size: 0.8rem;
                    div {
                        //flex: 1;
                        font-size: 0.7rem;
                      //  line-height: 1.7rem;
                        &:last-child {
                            text-align: right;
                        }
                        img {
                            width: 0.7rem;
                            height: 0.7rem;
                        }
                    }
                }
                .left_top {
                    display: inline-flex; 
                    flex-flow: column wrap; 
                    justify-content: space-between; 
                    align-items: flex-start;
                    .left_top_chart {
                        width: 100%;
                        height: 100%;
                        background: url(../../../assets/image/custom/elec_mac.png) no-repeat;
                        background-size: auto 90%;
                        background-position: top center;
                        .echarts {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .elec_custom_line {
                    display: inline-flex;
                    width: 100%;
                    align-items: center;
                    font-size: 0.8rem;
                    justify-content: center;
                    .elec_item_line_pic {
                        width: 1rem;
                        img {
                            width: 0.8rem;
                        }
                    }
                    .elec_item_line_cnt {
                        width: 50%;
                    }
                }
                .elec_custom {
                    width: 100%; 
                    flex: none !important;
                    .elec_item_inner {
                        width: 100%;
                        height: 100%;
                        display: inline-flex;
                        justify-content: space-evenly;
                        flex-flow: column wrap;
                        .inner_item {
                            font-size: 0.7rem;
                            display: inline-flex;
                            div {
                                flex: 1;
                                height: 0.7rem;
                                text-align: left;
                                &:not(:first-child) {
                                    text-align: right;
                                }
                                .inner_pic {
                                    width: 0.8rem;
                                    height: 0.8rem;
                                }
                            }
                            .more_pic {
                                width: 100%;
                                height: auto;
                                
                            }
                            .more_pic_txt {
                                position: absolute; 
                                top: 50%;
                                left: 50%;
                                color: #fff; 
                                font-size: 0.7rem; 
                                transform: translate(-50%, -50%);
                            }
                        }
                    }
                }
            }
            .elec_left_top {
                width: 100%;
                height: 53%;
                background: url(../../../assets/image/custom/elec_left_bottom.png) no-repeat;
                color: #fff;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding: 0.6rem 2rem 1.2rem;
            }
            .elec_left_center {
                width: 100%;
                height: 43%;
                background: url(../../../assets/image/custom/elec_left_center.png) no-repeat;
                color: #fff;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding: 0.6rem 2rem 1.2rem;
            }
            .elec_left_bottom {
                width: 100%;
                height: 48%;
                background: url(../../../assets/image/custom/elec_left_bottom.png) no-repeat;
                color: #fff;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding: 0.6rem 2rem;
                .left_bottom_choose {
                    width: 100%; display: inline-flex;justify-content: space-evenly;
                    div {
                        width: 3rem;height: 1rem; border: 1px solid #56fcff; border-radius: 1rem; text-align: center; font-size: 0.8rem; line-height: 1rem;cursor:pointer;
                    }
                    .choose_s {
                        background: #56fcff;
                        color: #000;
                    }
                    .choose_us {
                        background: transparent;
                        color: #fff;
                    }
                }
            }        
            .elec_chart_div {
                width: 100%;
                height: calc(100% - 4rem);
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .elec_right {
            width: 73%;
            display: inline-flex;
            flex-flow: column wrap;
            justify-content: space-between;
            .elec_right_item {
                width: 100%;
                height: 48.5%;
                background: url(../../../assets/image/custom/elec_big_bac.png) no-repeat;
                background-size: 100% 100%;
                padding: 1rem;
                box-sizing: border-box;
                .elec_title_div {
                    width: 15rem;
                    margin-bottom: 0.3rem;
                    position: relative;
                    span {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #56FCFF;
                        font-size: 0.6rem;
                    }
                    .elec_title {
                        width: 80%;
                        margin-left: 10%;
                        height: 1.2rem;
                    }

                }
                .tab_cont {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    .btn_cont {
                        text-align: right;width: 20rem;
                    }
                }
                .chart_cont {
                    width: 100%;
                    height: calc(100% - 6.5rem);
                    margin-top: 0.5rem;
                    .echart-container {
                        width: 100%;
                        height: 100%;
                        .echarts {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .table-container {
                        width: 100%;
                        height: 100%;
                        table {
                            width: auto !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
